import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import type { SelectedSpot } from './types'
import dayjs from 'dayjs'
import { bookingDefaultDate } from '../../../components/Datepicker/utils/utils'
import React from 'react'

export const selectedSpotsAtom = atom<SelectedSpot[]>([])

export const selectedDateAtom = atom<dayjs.Dayjs>(bookingDefaultDate)

export const bookingIdAtom = atomWithReset<string>('')

export const imageRefAtom = atom<React.MutableRefObject<HTMLImageElement | null>>(React.createRef<HTMLImageElement>())
